// extracted by mini-css-extract-plugin
export default {"success":"paymentStatus_success__gh-GZ","error":"paymentStatus_error__2CKYW","authorized":"paymentStatus_authorized__+U8WM"};